"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
define('rs/modals/system.report.modal/system.report.modal.view',['require','exports','module','underscore','select2','e3-modal'],function (require, exports, module) {
  var _ = require('underscore');
  var select2 = require('select2');
  var E3Modal = require('e3-modal');
  var SystemReportModalView = E3Modal.SectionView.extend({
    templates: {
      'system.report.modal': 'renderInitFragment'
    },
    events: {
      'change .modal-input-wrapper-one > select': 'systemReportInputOneChange',
      'change .modal-input-wrapper-two > select': 'systemReportInputTwoChange'
    },
    render: function render() {
      var _this$getDelegate3, _this$getDelegate4;
      var properties = this.getDelegate().props,
        self = this;
      this.$el.html(this.renderInitFragment(properties));
      this.listenTo(this.delegate.systemReportOneModel, 'sync', function (model, response, options) {
        var _this$getDelegate;
        this.delegate.systemReportOneModel.set('systemReportOneList', response === null || response === void 0 ? void 0 : response.data);
        var list = this.delegate.systemReportOneModel.toJSON().systemReportOneList;
        this.dropdownRender('modal-input-wrapper-one', this.lookupValuesList(list), (_this$getDelegate = this.getDelegate()) === null || _this$getDelegate === void 0 || (_this$getDelegate = _this$getDelegate.props) === null || _this$getDelegate === void 0 ? void 0 : _this$getDelegate.lookupLabelOneType);
      });
      this.listenTo(this.delegate.systemReportTwoModel, 'sync', function (model, response, options) {
        var _this$getDelegate2;
        this.delegate.systemReportTwoModel.set('systemReportTwoList', response === null || response === void 0 ? void 0 : response.data);
        var list = this.delegate.systemReportTwoModel.toJSON().systemReportTwoList;
        this.dropdownRender('modal-input-wrapper-two', this.lookupValuesList(list), (_this$getDelegate2 = this.getDelegate()) === null || _this$getDelegate2 === void 0 || (_this$getDelegate2 = _this$getDelegate2.props) === null || _this$getDelegate2 === void 0 ? void 0 : _this$getDelegate2.lookupLabelTwoType);
      });
      this.dropdownRender('modal-input-wrapper-one', [], (_this$getDelegate3 = this.getDelegate()) === null || _this$getDelegate3 === void 0 || (_this$getDelegate3 = _this$getDelegate3.props) === null || _this$getDelegate3 === void 0 ? void 0 : _this$getDelegate3.lookupLabelOneType);
      this.dropdownRender('modal-input-wrapper-two', [], (_this$getDelegate4 = this.getDelegate()) === null || _this$getDelegate4 === void 0 || (_this$getDelegate4 = _this$getDelegate4.props) === null || _this$getDelegate4 === void 0 ? void 0 : _this$getDelegate4.lookupLabelTwoType);
      var view = this.getDelegate().getModal().getView();
      view.$el.find('.modal-dialog').addClass('find-sponsor-modal-container');
      view.$el.find('.modal-input-wrapper-one > label').attr('tabindex', "0");
      view.$el.find('.modal-input-wrapper-two > label').attr('tabindex', "0");
      view.$el.on('keydown', '.btn.btn-primary', function (ev) {
        if (ev.keyCode == 13) {
          self.handleConfirmKeydown(ev);
        }
      }).on('keydown', '.btn.btn-default', function (ev) {
        if (ev.keyCode == 13) {
          self.handleCancelKeydown(ev);
        }
      }).on('change', '.modal-input-wrapper-one > select', function () {
        var data = self.delegate.systemReportOneModel.get('selectedSystemReportOneList');
        view.$el.find('.btn.btn-primary').attr('disabled', false);
        if (_.isArray(data) && (data === null || data === void 0 ? void 0 : data.length) === 1 && data !== null && data !== void 0 && data.includes('All')) {
          view.$el.find('.modal-input-wrapper-one > select').val(data);
        } else if (_.isArray(data) && (data === null || data === void 0 ? void 0 : data.length) > 1) {
          if (!(data !== null && data !== void 0 && data.includes('All'))) {
            view.$el.find('.modal-input-wrapper-one > select').val(data);
          } else if (data !== null && data !== void 0 && data.includes('All')) {
            var values = _.filter(data, function (val) {
              if ((data === null || data === void 0 ? void 0 : data.length) === 2) {
                return val !== 'All';
              } else return val === 'All';
            });
            view.$el.find('.modal-input-wrapper-one > select').val(values).trigger('change');
          }
        } else if (_.isEmpty(data)) {
          view.$el.find('.btn.btn-primary').attr('disabled', true);
        }
      }).on('change', '.modal-input-wrapper-two > select', function () {
        var data = self.delegate.systemReportTwoModel.get('selectedSystemReportTwoList');
        view.$el.find('.btn.btn-primary').attr('disabled', false);
        if (_.isArray(data) && (data === null || data === void 0 ? void 0 : data.length) === 1 && data !== null && data !== void 0 && data.includes('All')) {
          view.$el.find('.modal-input-wrapper-two > select').val(data);
        } else if (_.isArray(data) && (data === null || data === void 0 ? void 0 : data.length) > 1) {
          if (!(data !== null && data !== void 0 && data.includes('All'))) {
            view.$el.find('.modal-input-wrapper-two > select').val(data);
          } else if (data !== null && data !== void 0 && data.includes('All')) {
            var values = _.filter(data, function (val) {
              if ((data === null || data === void 0 ? void 0 : data.length) === 2) {
                return val !== 'All';
              } else return val === 'All';
            });
            view.$el.find('.modal-input-wrapper-two > select').val(values).trigger('change');
          }
        } else if (_.isEmpty(data)) {
          view.$el.find('.btn.btn-primary').attr('disabled', true);
        }
      }).on('keyup', '.modal-input-wrapper-one > span > span.selection > span > ul', function () {
        this.ariaLabel = self.delegate.systemReportOneModel.get('selectedSystemReportOneListWithDesc');
        this.tabIndex = 0;
      }).on('keyup', '.modal-input-wrapper-two > span > span.selection > span > ul', function () {
        this.ariaLabel = self.delegate.systemReportTwoModel.get('selectedSystemReportTwoListWithDesc');
        this.tabIndex = 0;
      }).on('keyup', '.modal-input-wrapper-one > label', function () {
        view.$el.find('.modal-input-wrapper-one > span > span.selection > span > ul').attr('tabindex', "0");
      }).on('keyup', '.modal-input-wrapper-two > label', function () {
        view.$el.find('.modal-input-wrapper-two > span > span.selection > span > ul').attr('tabindex', "0");
      });
    },
    dropdownRender: function dropdownRender(className) {
      var _data$;
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var type = arguments.length > 2 ? arguments[2] : undefined;
      var view = this.getDelegate().getModal().getView();
      view.$el.find(".".concat(className, " > select")).select2({
        width: '100%',
        data: data.length > 0 ? data : [],
        templateSelection: this.formatSelection,
        templateResult: this.formatResult,
        placeholder: 'Select',
        multiple: type === 'single' ? false : true,
        closeOnSelect: false,
        minimumResultsForSearch: type === 'single' ? Infinity : 0
      }).val((_data$ = data[0]) === null || _data$ === void 0 ? void 0 : _data$.id).trigger('change');
    },
    handleConfirmAction: function handleConfirmAction() {
      var delegate = this.getDelegate(),
        systemReportOneList = delegate.systemReportOneModel.get('selectedSystemReportOneList'),
        systemReportTwoList = delegate.systemReportTwoModel.get('selectedSystemReportTwoList'),
        props = delegate.props,
        formData = {};
      Object.entries(props).forEach(function (item) {
        var _item = _slicedToArray(item, 2),
          key = _item[0],
          value = _item[1];
        if (key.includes('systemReportInputOne')) {
          formData[value] = systemReportOneList;
        } else if (key.includes('systemReportInputTwo')) {
          formData[value] = systemReportTwoList;
        }
      });
      if (props.lookupLabelOneType === 'single') {
        var _formData;
        formData = _objectSpread(_objectSpread({}, formData), {}, {
          assignments: (_formData = formData) === null || _formData === void 0 || (_formData = _formData.assignments) === null || _formData === void 0 ? void 0 : _formData.split()
        });
      }
      this.getDelegate().requestSaveItems(formData);
    },
    handleCancelAction: function handleCancelAction() {
      this.delegate.reportModel.stopListening();
    },
    handleConfirmKeydown: function handleConfirmKeydown(ev) {
      this.handleConfirmAction(ev);
    },
    handleCancelKeydown: function handleCancelKeydown() {
      this.handleCancelAction();
    },
    formatResult: function formatResult(item) {
      return item.text;
    },
    formatSelection: function formatSelection(item) {
      return item.text;
    },
    systemReportInputOneChange: function systemReportInputOneChange() {
      var $multiSelect = this.$el.find('.modal-input-wrapper-one > select');
      var selectedValues = $multiSelect.val();
      this.getDelegate().systemReportOneModel.set('selectedSystemReportOneList', selectedValues);
      var selectedList = _.filter(this.getDelegate().systemReportOneModel.toJSON().systemReportOneList, function (val) {
        var _val$id;
        if (val.id == null && selectedValues !== null && selectedValues !== void 0 && selectedValues.includes('All')) {
          return val.description;
        } else if (selectedValues !== null && selectedValues !== void 0 && selectedValues.includes((_val$id = val.id) === null || _val$id === void 0 ? void 0 : _val$id.toString())) {
          return val.description;
        } else return;
      });
      var selectedListWithDesc = selectedList.map(function (val) {
        return _.isString(val.description) ? val.description : _.isString(val.value) ? val.value : '';
      });
      this.getDelegate().systemReportOneModel.set('selectedSystemReportOneListWithDesc', selectedListWithDesc);
    },
    systemReportInputTwoChange: function systemReportInputTwoChange() {
      var $multiSelect = this.$el.find('.modal-input-wrapper-two > select');
      var selectedValues = $multiSelect.val();
      this.getDelegate().systemReportTwoModel.set('selectedSystemReportTwoList', selectedValues);
      var selectedList = _.filter(this.getDelegate().systemReportTwoModel.toJSON().systemReportTwoList, function (val) {
        var _val$id2;
        if (val.id == null && selectedValues !== null && selectedValues !== void 0 && selectedValues.includes('All')) {
          return val.description;
        } else if (selectedValues !== null && selectedValues !== void 0 && selectedValues.includes((_val$id2 = val.id) === null || _val$id2 === void 0 ? void 0 : _val$id2.toString())) {
          return val.description;
        } else return;
      });
      var selectedListWithDesc = selectedList.map(function (val) {
        return _.isString(val.description) ? val.description : _.isString(val.value) ? val.value : '';
      });
      this.getDelegate().systemReportTwoModel.set('selectedSystemReportTwoListWithDesc', selectedListWithDesc);
    },
    lookupValuesList: function lookupValuesList(list) {
      if (_.isArray(list) && (list === null || list === void 0 ? void 0 : list.length) > 0) {
        var lookupList = list.map(function (status) {
          if (status.value === 'All') {
            return {
              id: status.value,
              text: status.value
            };
          } else if (_.isString(status.description)) {
            return {
              id: status.id,
              text: status.description
            };
          } else if (_.isString(status.name)) {
            return {
              id: status.id,
              text: status.name
            };
          } else return {
            id: status.id,
            text: status.value
          };
        });
        return _.isArray(lookupList) ? lookupList : [];
      }
    }
  });
  module.exports = SystemReportModalView;
});

